import { render } from "./AppLoader.vue?vue&type=template&id=485c514e&scoped=true&ts=true"
import script from "./AppLoader.vue?vue&type=script&lang=ts"
export * from "./AppLoader.vue?vue&type=script&lang=ts"

import "./AppLoader.vue?vue&type=style&index=0&id=485c514e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-485c514e"]])

export default __exports__